import React from 'react';
import AnnunciFamiglie from './AnnunciFamiglie';
import AnnunciOperatoreSportelli from './AnnunciOperatoreSportelli';
import AnnunciAssistenteFamiliare from './AnnunciAssistenteFamiliare';

function Annunci() {
    const sessioneUtente = sessionStorage.getItem("sessioneUtente")
        ? JSON.parse(sessionStorage.getItem("sessioneUtente"))
        : {}
    const tipoUtente = sessioneUtente.tipoUtente

    if (tipoUtente === "04") return <AnnunciFamiglie/>
    if (tipoUtente === "01") return <AnnunciOperatoreSportelli/>
    if (tipoUtente === "02") return <AnnunciAssistenteFamiliare/>
    return null
}

export default Annunci
